import { createChildListPrintContainer } from 'factories/ChildListPrint'
import actions from 'actions/requisitions/requisitionItems'
import Component from 'components/Requisitions/Print/Items'

export default createChildListPrintContainer({
  actions,
  extraStateToProps: (state, props) => ({ settingsType: props.settingsType ?? 'requisition' }),
})(Component)
